import React from "react";

import { Header, Segment } from "semantic-ui-react";

const Footer: React.FC = () => {
    return (
        <footer>
            <Segment
                inverted
                vertical
                style={{ margin: "2em 0em 0em", padding: "3em 0em" }}
                textAlign="center"
            >
                <Header as="h4">Poder Feminino App</Header>
                ver. 1.0.0
            </Segment>
        </footer>
    );
};

export default Footer;
